<div class="auth-screen">
  <div class="auth-card">
    <div class="auth-logo">
      <img
        src="assets/images/OmniFlow-Logo.png"
        class="auth-logo__img"
        [alt]="T.common.appName"
      />
    </div>
    <div class="auth-spinner"></div>
    <p class="auth-message" data-testid="login-landing-message">{{ T.loginLanding.signingYouIn }}</p>
  </div>
</div>
